import {
	DateField,
	FormDrawerContent,
	FormDrawerContentProps,
	FormFetchDrawer,
	SingleSelectField,
	TextField,
	UpdateDrawerFormProps,
} from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { BranchSelectField } from "~root/branches/BranchSelectField";
import { CountrySelectField, StateSelectField } from "~root/country/CountrySelectField";
import { UserSelectField } from "~root/users/UserSelectField";
import { employeeKeys } from "~shared/api/employee/employeeKeys";
import { webserviceApi } from "~shared/api/webserviceApi";
import { ALL_GENDERS, IEmployeeUpdateFormState } from "~shared/types";

const useValidate = () => {
	const { t } = useTranslation();

	return (values: IEmployeeUpdateFormState) => {
		const errors: { [K in keyof IEmployeeUpdateFormState]?: any } = {};

		if (!values.firstName) {
			errors.firstName = t("Field is required");
		}
		if (!values.lastName) {
			errors.lastName = t("Field is required");
		}
		if (!values.dateOfBirth) {
			errors.dateOfBirth = t("Field is required");
		}
		if (!values.employeeNumber) {
			errors.employeeNumber = t("Field is required");
		}
		return errors;
	};
};
const EmployeeDrawerContent: FC<FormDrawerContentProps> = (props) => {
	const { t } = useTranslation();

	return (
		<FormDrawerContent {...props}>
			<TextField name="firstName" label={t("First name")} required />
			<TextField name="lastName" label={t("Last name")} required />
			<TextField name="employeeNumber" label={t("Employee number")} required />
			<TextField name="street" label={t("Street")} />
			<TextField name="houseNumber" label={t("House number")} />
			<TextField name="postalCode" label={t("Postal code")} />
			<TextField name="city" label={t("City")} />
			<CountrySelectField name="country" label={t("Country")} />
			<StateSelectField name="state" label={t("State")} />
			<TextField name="placeOfBirth" label={t("Place of birth")} />
			<TextField name="countryOfBirth" label={t("Country of birth")} />
			<DateField name="dateOfBirth" label={t("Date of birth")} required />
			<SingleSelectField name="gender" label={t("Gender")} options={[...ALL_GENDERS]} getLabel={t} />
			<BranchSelectField name="branch" label={t("Branch")} />
			<TextField name="iban" label={t("IBAN")} />
			<UserSelectField name="user" label={t("User")} />
		</FormDrawerContent>
	);
};

export const EmployeeUpdateDrawer: FC<UpdateDrawerFormProps<IEmployeeUpdateFormState>> = (drawerProps) => {
	const { t } = useTranslation();
	const validate = useValidate();

	return (
		<FormFetchDrawer
			{...drawerProps}
			title={t("Edit employee")}
			queryFn={() => webserviceApi.showEmployee(+drawerProps.id).then((x) => x.data.data)}
			queryKey={employeeKeys.detail(drawerProps.id)}
			validate={validate}
			renderSuccess={(props) => <EmployeeDrawerContent {...props} />}
		/>
	);
};
